/**
 * RowFilter lets you filter the table by not altering the original dataset. For
 * example, you may have some search component that returns a list of matching
 * results and you want to filter the table. You can pass the IDs to RowFilter
 * and it will hide the rows that don't match. And when you want to reset the
 * filtering you can just call reset();.  Once you're filtered or reset the data
 * you will have to call update(); to trigger the table to rebuild.
 *
 * @example
 * var onSearch = function (results) {
 *   var rowFilter = batchGeoTable.RowFilter;
 *
 *   // Get the IDs in an array like [1,2] from an obj like {1: {...}, 2: {...}}
 *   var rowIds = Object.keys(results);
 *
 *   // If there was results filter them otherwise reset and show all data again
 *   rowIds.length ? rowFilter.filterByIds(results) : rowFilter.reset();
 *
 *   // Now trigger the table to rebuild
 *   rowFilter.update();
 * }
 */
(function () {
  var RowFilter = function () {
    var self = this;

    /**
     * Filters down the visible rows by the IDs passed.
     *
     * @param  {array|number} ids The ID (like `2`) or an array of IDs (`[2,3]`)
     * @return {undefined}
     */
    var filterByIds = function (ids) {
      self.setDisplayData(self.getRowData(ids));
    };

    /**
     * Resets the data back to showing all data again without any filters
     *
     * @return {undefined}
     */
    var reset = function () {
      self.resetDisplayData();
    };

    /**
     * Re-renders the table rows
     *
     * @return {undefined}
     */
    var update = function () {
      self.rebuildRows();
    };

    // Public API
    self.RowFilter = {
      filterByIds: filterByIds,
      reset: reset,
      update: update,
    };
  };

  window.RowFilter = RowFilter;
})(window);
